import React, { useState } from 'react';

import SecondaryNavBar from '../../../Components/SecondaryNavBar/SecondaryNavBar';
import DOMPurify from 'dompurify';

import LoadingOverlay from 'Components/LoadingOverlay/LoadingOverlay';
import { renderError } from 'utils/formUtils';

import 'Container/Formulaires/ChangementCoordonnees/ChangementCoordonnees.scss';
import { useSelector } from "react-redux";
import { postChangementContrat } from "../../../api/modificationContratService";
import MessageInfoEnvoi from "../../../Components/Formulaire/MessageInfoEnvoi/MessageInfoEnvoi";

export default function ChangementCoordonnees({ isInside }) {

    const {
        detailPersonne,
        contrat,
        contratsBeneficiaires,
        infosComplementaires,
        infosCorrespondant,
        keycloakReduce,
    } = useSelector(state => ({
        ...state.gestionContratReducer,
        ...state.keycloakReducer,
    }))

    const CONF = window?.confPub;
    const FORMULAIRES_UI = CONF?.UI?.FORMULAIRES;
    const COMMUN_INPUTS = FORMULAIRES_UI?.COMMUN_INPUTS
    const UI = FORMULAIRES_UI?.CHANGEMENT_COORDONNEES;
    const INPUTS = UI?.INPUTS;
    const ROUTES = CONF.ROUTES;
    const CODES_FORMULAIRES = CONF?.CODES?.CODES_FORMULAIRES;
    const REGEX = CONF?.UI.REGEX;

    const [submitted, setSubmitted] = useState(false)
    const [disabledForm, setDisabledForm] = useState(false);
    const [sendSuccess, setSendSuccess] = useState({
        isSuccess: false,
        message: false,
        display: false,
    })

    const initialState = {
        [COMMUN_INPUTS?.TELEPHONE_FIXE?.NAME]: {
            name: COMMUN_INPUTS?.TELEPHONE_FIXE?.NAME,
            value: '',
            ref: detailPersonne?.telPrincipal ?? '',
            invalid: false,
            label: COMMUN_INPUTS?.TELEPHONE_FIXE?.LABEL_NEW,
        },
        [COMMUN_INPUTS?.TELEPHONE_PORTABLE?.NAME]: {
            name: COMMUN_INPUTS?.TELEPHONE_PORTABLE?.NAME,
            value: '',
            ref: detailPersonne?.telMobile ?? '',
            invalid: false,
            label: COMMUN_INPUTS?.TELEPHONE_PORTABLE?.LABEL_NEW,
        },
        [COMMUN_INPUTS?.EMAIL?.NAME]: {
            name: COMMUN_INPUTS?.EMAIL?.NAME,
            value: '',
            ref: detailPersonne?.email ?? '',
            invalid: false,
            label: COMMUN_INPUTS?.EMAIL?.LABEL_NEW,
        },
    }

    const [coordonneesForm, setCoordonneesForm] = useState(initialState)

    const checkInput = (name, value, ref) => {

        const trimValue = typeof value === "string" ? value?.trim() : value
        let invalid = null

        const regexEmail = CONF?.UI?.REGEX?.EMAIL
        const regexTelephone = CONF?.UI?.REGEX?.TELEPHONE_FIXE

        switch (name) {

            case COMMUN_INPUTS?.TELEPHONE?.NAME:
            case COMMUN_INPUTS?.TELEPHONE_PORTABLE?.NAME:
            case COMMUN_INPUTS?.TELEPHONE_FIXE?.NAME:

                if (!value) {

                    invalid = "Champ vide"
                } else if (value && !new RegExp(regexTelephone).test(trimValue)) {

                    invalid = "Le numéro de téléphone est invalide."

                } else if (trimValue === ref) {

                    invalid = "Le numéro de téléphone est identique à celui déjà enregistré."
                }
                break

            case COMMUN_INPUTS?.EMAIL?.NAME:

                if (!value) {

                    invalid = "Champ vide"
                } else if (value && !new RegExp(regexEmail).test(trimValue)) {

                    invalid = "L'email est invalide."

                } else if (trimValue === ref) {

                    invalid = "L'email est identique à celui déjà enregistré."
                }
                break
        }

        return invalid
    }

    const handleInput = (e) => {

        const { value, name } = e?.target

        const invalid = checkInput(name, value, coordonneesForm?.[name]?.ref)

        setCoordonneesForm((prev) => ({
            ...prev,
            [name]: {
                ...prev?.[name],
                value: value,
                invalid: invalid,
            }
        }))
    }

    const checkValidNewCoordonnees = () => {

        const coordonneesMaj = [];

        Object.entries(coordonneesForm).forEach(([key, coordonnee]) => {

            const invalid = checkInput(coordonnee?.name, coordonnee?.value, coordonnee?.ref)

            if (!invalid && coordonnee?.value) {
                coordonneesMaj.push({
                    label: coordonnee?.label,
                    valeur: coordonnee?.value
                })
            }
        });

        return coordonneesMaj
    }

    const submitForm = async (e) => {

        e.preventDefault();
        setDisabledForm(true);

        const coordonneesMaj = checkValidNewCoordonnees()

        console.log("coordonneesMaj")
        console.log(coordonneesMaj)

        // TODO afficher un message après envoi
        if (coordonneesMaj?.length > 0) {

            const formToSend = {
                idGrm: keycloakReduce?.decodedToken?.idGrm,
                idGrcDemandeur: infosCorrespondant?.idGrc,
                idGrcBeneficiaire: detailPersonne?.idPersGrc,
                codeDomaine: contrat?.gammeContrat,
                codeQualification: CODES_FORMULAIRES?.CHANGEMENT_COORDONNEES,
                champ: coordonneesMaj,
            }

            try {

                const resp = await postChangementContrat(formToSend)

                console.log("resp")
                console.log(resp)

                setSendSuccess({
                    isSuccess: !!resp?.data?.idGrcDemande,
                    message: false,
                    display: true,
                })

                erasedInputs(false);

            } catch (err) {
                console.log("err", err);

                setSendSuccess({
                    isSuccess: false,
                    message: false,
                    display: true,
                })

                setSubmitted(true);

            } finally {
                setDisabledForm(false);
            }

        } else {
            console.log("Formulaire pas valide")
            setDisabledForm(false);

            setSendSuccess({
                display: true,
                isSuccess: false,
                message: "Vous devez renseigner au moins une nouvelle coordonnée",
            })

            setSubmitted(true);
        }
    }

    const erasedInputs = (all) => {

        setCoordonneesForm(initialState)

        if (all) {
            setSubmitted(false)
            setSendSuccess({
                isSuccess: false,
                message: false,
                display: false,
            })
        }
    }

    return (

        <div className="container mt-3">
            { !isInside && <SecondaryNavBar /> }

            <main id='content' className='overlay-container'>

                { disabledForm && <LoadingOverlay classes="upload-overlay"/> }

                <div className={ `${ !isInside ? 'col-lg-8' : '' }` }>

                    <div className="card">

                        <form onSubmit={ submitForm }>

                            <div className="card-header">
                                <h2>Changement de coordonnées</h2>
                            </div>

                            <div className="card-body mb-3">

                                <div>
                                    <h4>Coordonnées actuelles :</h4>
                                </div>

                                <dl className="row">
                                    <dt className="col-sm-5">
                                        Téléphone fixe :
                                    </dt>
                                    <dd className="col-sm-7">
                                        { detailPersonne?.telPrincipal ? detailPersonne?.telPrincipal : 'Non renseigné' }
                                    </dd>

                                    <dt className="col-sm-5">
                                        Téléphone portable :
                                    </dt>
                                    <dd className="col-sm-7">
                                        { detailPersonne?.telMobile ? detailPersonne?.telMobile : 'Non renseigné' }
                                    </dd>

                                    <dt className="col-sm-5">
                                        Email :
                                    </dt>
                                    <dd className="col-sm-7">
                                        { detailPersonne?.email ? detailPersonne?.email : 'Non renseigné' }
                                    </dd>
                                </dl>

                                <div className="row">

                                    <h4>Nouvelles coordonnées :</h4>

                                    <div className='col-lg-6 mt-2'>
                                        <label htmlFor="" className="form-label" dangerouslySetInnerHTML={ {
                                            __html: DOMPurify.sanitize(INPUTS?.TELEPHONE_FIXE?.LABEL)
                                        } }/>
                                        <input type="text"
                                               name={ INPUTS?.TELEPHONE_FIXE?.NAME }
                                               className={ `form-control ${ submitted && coordonneesForm?.[INPUTS?.TELEPHONE_FIXE?.NAME]?.invalid ? 'is-invalid' : '' }` }
                                               placeholder={ INPUTS?.TELEPHONE_FIXE?.PLACEHOLDER }
                                               value={ coordonneesForm?.[INPUTS?.TELEPHONE_FIXE?.NAME]?.value }
                                               onChange={ handleInput }/>

                                        { submitted && coordonneesForm?.[INPUTS?.TELEPHONE_FIXE?.NAME]?.invalid
                                            && renderError(coordonneesForm?.[INPUTS?.TELEPHONE_FIXE?.NAME]?.invalid) }
                                    </div>

                                    <div className='col-lg-6 mt-2'>
                                        <label htmlFor="" className="form-label" dangerouslySetInnerHTML={ {
                                            __html: DOMPurify.sanitize(INPUTS?.TELEPHONE_PORTABLE?.LABEL)
                                        } }/>
                                        <input type="text"
                                               name={ INPUTS?.TELEPHONE_PORTABLE?.NAME }
                                               className={ `form-control ${ submitted && coordonneesForm?.[INPUTS?.TELEPHONE_PORTABLE?.NAME]?.invalid ? 'is-invalid' : '' }` }
                                               placeholder={ INPUTS?.TELEPHONE_PORTABLE?.PLACEHOLDER }
                                               value={ coordonneesForm?.[INPUTS?.TELEPHONE_PORTABLE?.NAME]?.value }
                                               onChange={ handleInput }/>

                                        { submitted && coordonneesForm?.[INPUTS?.TELEPHONE_PORTABLE?.NAME]?.invalid
                                            && renderError(coordonneesForm?.[INPUTS?.TELEPHONE_PORTABLE?.NAME]?.invalid) }
                                    </div>

                                    <div className='col-lg-6 mt-2'>
                                        <label htmlFor="" className="form-label" dangerouslySetInnerHTML={ {
                                            __html: DOMPurify.sanitize(INPUTS?.EMAIL?.LABEL)
                                        } }/>
                                        <input type="text"
                                               name={ INPUTS?.EMAIL?.NAME }
                                               className={ `form-control ${ submitted && coordonneesForm?.[INPUTS?.EMAIL?.NAME]?.invalid ? 'is-invalid' : '' }` }
                                               placeholder={ INPUTS?.EMAIL?.PLACEHOLDER }
                                               value={ coordonneesForm?.[INPUTS?.EMAIL?.NAME]?.value }
                                               onChange={ handleInput }/>

                                        { submitted && coordonneesForm?.[INPUTS?.EMAIL?.NAME]?.invalid
                                            && renderError(coordonneesForm?.[INPUTS?.EMAIL?.NAME]?.invalid) }
                                    </div>
                                </div>

                                <MessageInfoEnvoi
                                    isSuccess={ sendSuccess?.isSuccess }
                                    message={ sendSuccess?.message }
                                    display={ sendSuccess?.display }
                                />
                            </div>

                            <div className="card-footer">
                                <div className='d-flex justify-content-end'>
                                    <button type='submit'
                                            className="btn btn-primary"
                                    >
                                        Envoyer
                                    </button>
                                    <button type='button'
                                            onClick={ () => erasedInputs(true) }
                                            className="btn btn-secondary ms-2">
                                        Effacer
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </main>
        </div>
    )
}
